// extracted by mini-css-extract-plugin
export default {"truncate":"receiptScreen_truncate__pwRTU","spanForPayment":"receiptScreen_spanForPayment__nO8XO","divForPayment":"receiptScreen_divForPayment__8xgys"};